import React, { useEffect } from 'react';

import { store } from 'redux/store';
import { setCurrentTab } from 'redux/reducers/meteorologyFieldsLayoutReducer';
import SynopticChart from 'components/Meteorology/Fields/SynopticCharts/SynopticChart';
import SynopticChartsMobile from 'components/Meteorology/Fields/SynopticCharts/Mobile';
import useIsMobile from 'utils/hooks/useIsMobile';

import './index.scss';

export default function SynopticCharts() {
  const isMobile = useIsMobile();

  useEffect(() => {
    store.dispatch(setCurrentTab('synopticcharts'));
  }, []);

  if (isMobile) {
    return <SynopticChartsMobile />;
  }

  return (
    <div className="synoptic-chart-display">
      <SynopticChart />
    </div>
  );
}
